import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userManagementBaseUrl, userManagement } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const memberCategoryMasterService = createApi({
  reducerPath: "memberCategoryMasterService",
  baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
  tagTypes: ["memberCategoryMaster"],
  endpoints: (builder) => ({
    getAllMemberCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberCategoryMasterController.getAllMemberCategoryMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
          method: "GET",
           headers: { Authorization: `Bearer ${body.token}`},
          // body: body.payload,
        };
      },
    }),
    getAllMemberCategoryMasterBySearch: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberCategoryMasterController.getAllMemberCategoryMasterBySearch}`,
          method: "POST",
          headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    updateMemberCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberCategoryMasterController.updateMemberCategoryMaster}/${body.id}`,
          method: "PUT",
           headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    deleteMemberCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberCategoryMasterController.deleteMemberCategoryMaster}/${body.id}`,
          method: "DELETE",
           headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getMemberCategoryMasterById: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberCategoryMasterController.getMemberCategoryMasterById}/${body.id}`,
          method: "GET",
           headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    saveMemberCategoryMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberCategoryMasterController.saveMemberCategoryMaster}`,
          method: "POST",
           headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    findAllMemberCategoryMasterMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberCategoryMasterController.findAllMemberCategoryMasterMaster}`,
          method: "GET",
           headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    bulkSaveMemberCategoryMasterMaster: builder.mutation({
      query(body) {
        return {
          url: `${userManagement.memberCategoryMasterController.bulkSaveMemberCategoryMasterMaster}`,
          method: 'POST',
           headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        }
      }
    }),
  }),
});
export const {
  useGetAllMemberCategoryMasterMutation,
  useGetAllMemberCategoryMasterBySearchMutation,
  useUpdateMemberCategoryMasterMutation,
  useDeleteMemberCategoryMasterMutation,
  useGetMemberCategoryMasterByIdMutation,
  useSaveMemberCategoryMasterMutation,
  useFindAllMemberCategoryMasterMasterMutation,
  useBulkSaveMemberCategoryMasterMasterMutation,
} = memberCategoryMasterService;
